import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import { Button } from '@/components/form/Button';
import SiPlusCircle from '@/icons/SiPlusCircle';
import BreadcrumbPageHeader from '@/layouts/BreadcrumbPageHeader';
import { PageLoading } from '@/layouts/PageLoading';
import { Container } from '@/layouts/main/Main';
import { Partner } from '@/services/api/contracts/partners';
import { usePartners } from '@/services/api/hooks/partners';
import { PageTitle } from '@/utils/Title';
import { FunctionComponent, Suspense } from 'react';
import { useNavigate } from 'react-router';

import MspCard from './MspCard';

const MspsPageContent: FunctionComponent = () => {
  const navigate = useNavigate();
  const breadcrumbs: NavPage[] = [
    {
      name: 'MSPs',
      to: '/msps/manageMsps'
    }
  ];

  const [msps] = usePartners();

  return (
    <>
      <BreadcrumbPageHeader breadcrumbs={breadcrumbs}>
        <div className="flex justify-between gap-5 items-center font-bold">
          <h3 className="text-3xl">MSPs</h3>
          <Button className="h-fit" onClick={() => navigate('create')}>
            <SiPlusCircle className="text-xl" />
            <span>Create new MSP</span>
          </Button>
        </div>
      </BreadcrumbPageHeader>
      <div className="flex-1 overflow-y-auto">
        <Container animate="pop" className="w-full py-8">
          <div className="grid h-fit grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-4">
            {msps.map((msp: Partner) => (
              <MspCard msp={msp} key={msp.id} />
            ))}
          </div>
        </Container>
      </div>
    </>
  );
};

const MspsPage: FunctionComponent = () => {
  return (
    <>
      <PageTitle>MSPs</PageTitle>
      <Suspense fallback={<PageLoading />}>
        <MspsPageContent />
      </Suspense>
    </>
  );
};

export default MspsPage;
